import { Component } from '@angular/core';

@Component({
  selector: 'app-collaborators-settings',
  standalone: true,
  imports: [],
  templateUrl: './collaborators-settings.component.html',
  styleUrl: './collaborators-settings.component.scss'
})
export class CollaboratorsSettingsComponent {

}
